"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : ICON : STYLES --------------- ++++++++++ */


var iconSpaceSize = 7;
var _default = {
  icon: {
    // ----- space ----- //
    '&.space': {
      '&-left': {
        marginLeft: (0, _index.pxToEm)(iconSpaceSize)
      },
      '&-right': {
        marginRight: (0, _index.pxToEm)(iconSpaceSize)
      },
      '&-around': {
        marginLeft: (0, _index.pxToEm)(iconSpaceSize),
        marginRight: (0, _index.pxToEm)(iconSpaceSize)
      }
    },
    // ----- colors ----- //
    extend: (0, _index.themeStyleHelper)(_index.theme, 'color', function (theme, uniqueColor) {
      return {
        '& i': {
          color: uniqueColor ? theme.color[uniqueColor].medium.swatch : 'initial'
        }
      };
    })
  }
};
exports.default = _default;